import React, { useEffect, useState } from "react";
import { DashboardShell } from "@/components/yc/DashboardShell";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound, CheckCircle2, Sparkles } from "lucide-react";

const BrandAccessCode = () => {
    const [code, setCode] = useState("");
    const [busy, setBusy] = useState(false);
    const [access, setAccess] = useState(null);

    const load = () => api.get("/brand/access").then((r) => setAccess(r.data)).catch(() => {});
    useEffect(() => { load(); }, []);

    const redeem = async () => {
        if (!code.trim()) { toast.error("Please enter your access code"); return; }
        setBusy(true);
        try {
            const r = await api.post("/brand/redeem-code", { code: code.trim() });
            toast.success(r.data.message || "Access code applied");
            setCode("");
            await load();
        } catch (e) {
            toast.error(e.response?.data?.detail || "Could not apply that code");
        } finally { setBusy(false); }
    };

    const sponsor = access?.sponsor_free;

    return (
        <DashboardShell role="brand" title="Access code" subtitle="Enter a code shared by the Curated Chaos team">
            <div className="max-w-xl mx-auto w-full space-y-6">
                {sponsor && (
                    <div className="yc-card p-5 sm:p-6 bg-yc-pink text-white" data-testid="sponsor-active-banner">
                        <div className="flex items-center gap-2 font-heading font-bold text-lg">
                            <Sparkles className="w-5 h-5" /> Partner access active
                        </div>
                        <p className="text-sm text-white/90 mt-1">You can create campaigns for free. You can still buy a plan or top-ups anytime.</p>
                    </div>
                )}

                <div className="yc-card p-6 sm:p-8" data-testid="brand-code-redeem-card">
                    <div className="flex items-center gap-2">
                        <KeyRound className="w-5 h-5 text-yc-blue" />
                        <h2 className="font-heading text-xl sm:text-2xl font-bold">Have an access code?</h2>
                    </div>
                    <p className="text-sm text-yc-ink/70 mt-1">
                        Partner codes unlock free campaign creation instantly. Paste yours below.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 mt-5">
                        <input
                            data-testid="brand-redeem-code-input"
                            className="yc-input flex-1 font-mono tracking-widest uppercase"
                            placeholder="PARTNER-XXXXXX"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            onKeyDown={(e) => { if (e.key === "Enter") redeem(); }}
                        />
                        <button
                            data-testid="brand-redeem-code-btn"
                            disabled={busy}
                            onClick={redeem}
                            className="yc-btn-primary disabled:opacity-50 whitespace-nowrap"
                        >
                            Apply code
                        </button>
                    </div>
                    <div className="mt-5 flex items-start gap-2 text-sm text-yc-ink/70">
                        <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0 text-yc-blue" />
                        <span>Don't have a code? Codes are issued by the Curated Chaos team — <a href="mailto:info@curated-chaos.co.uk?subject=Access%20code%20request" className="text-yc-blue underline">get in touch</a>.</span>
                    </div>
                </div>
            </div>
        </DashboardShell>
    );
};

export default BrandAccessCode;
